module.exports = __webpack_public_path__ + "img/27b94baafaf04c2e96a2670e40844f7f-1024.6bdd70da.jpg";